<template>
  <div class="kkg-notification-cookie">
    <v-row dense>
      <v-col>
        <kk-dynamic-html :html="notificationData" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col class="d-flex justify-end">
        <v-btn outlined tile @click="accept"
          >{{ $t("Cookie.buttons.accept") }}
        </v-btn>
        <!-- <v-btn outlined tile @click="reject"
          >{{ $t("Cookies.buttons.reject") }}
        </v-btn> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import KkDynamicHtml from "./Article/KkDynamicHtml.vue";
export default {
  name: "KkgNotificationCookies",
  components: { KkDynamicHtml },
  props: {
    notificationData: {
      type: String,
      required: true,
    },
  },
  methods: {
    accept() {
      this.$store.dispatch("cookieConsent/changeValue", true);
      this.close();
    },
    reject() {
      this.$store.dispatch("cookieConsent/changeValue", false);
      this.close();
    },
    close() {
      this.$store.commit("cookieConsent/setShow", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.kkg-notification-cookie {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 0;
  height: auto;
  padding: 20px 70px 20px 20px;
  background-color: var(--v-bgSecondary-base);
  z-index: 270;
  box-shadow: 0px 13px 28px rgba(237, 34, 36, 0.25),
    0px 1px 30px rgba(237, 34, 36, 0.6);

  @media (min-width: 1024px) {
    padding: 40px 70px 40px 40px;
    left: 40px;
    right: 40px;
  }
}
</style>
